// REF01-M 3.8: readable label for the XREF01 <Refer><DiagnoseDescriptionCode>.
// The raw code stays visible; the label is shown next to it.

const REFER_DESCRIPTION_LABELS: Record<string, string> = {
  henv_diagnose_ny_sygdom: 'Sygdom: ny sygdom',
  henv_diagnose_samme_sygdom: 'Sygdom: samme sygdom',
  henv_diagnose: 'Sygdom: ikke angivet',
  speciallaegehenvisning: 'Speciallægehenvisning',
  fysioterapihenvisning: 'Fysioterapihenvisning',
  psykologhenvisning: 'Psykologhenvisning',
  fysioterapihenvisningspgruppe: 'Fysioterapihenvisning (gruppe)',
};

export function referDescriptionLabel(code: string | null | undefined): string | null {
  const key = (code ?? '').trim();
  return REFER_DESCRIPTION_LABELS[key] ?? null;
}

/** "henv_diagnose_ny_sygdom — Sygdom: ny sygdom"; an unknown code is shown as is. */
export function referDescriptionDisplay(code: string | null | undefined): string | null {
  const raw = (code ?? '').trim();
  if (!raw) return null;
  const label = referDescriptionLabel(raw);
  return label ? `${raw} — ${label}` : raw;
}
